import { Controller } from 'stimulus';
import cookie from '@/helpers/cookie';

const COOKIE_NAME = 'loader_seen';
const COOKIE_LIFETIME = 1440;
const MIN_WAIT_TIME = 2000;
const OPEN_CLASS = 'is-open';

class LoaderController extends Controller {
  connect() {
    this.isLoaded = false;
    this.minWaitTimeHit = false;
    let percentage = 0;

    const interval = setInterval(() => {
      percentage += 1;
      this.outputPercentage(percentage);

      if (percentage >= 99) {
        if (this.isLoaded) {
          percentage = 100;
          this.outputPercentage(percentage);
        }

        this.minWaitTimeHit = true;

        clearInterval(interval);
      }
    }, MIN_WAIT_TIME / 99);
  }

  onWindowLoad() {
    this.isLoaded = true;

    if (this.minWaitTimeHit) {
      this.outputPercentage(100);
    }
  }

  outputPercentage(percentage) {
    const truckPercentage = this.loaderTarget.offsetWidth * (percentage / 100);
    this.percentageTarget.innerText = percentage;

    if (this.hasTruckTarget) {
      this.truckTarget.style.transform = `translateX(${truckPercentage}px)`;
    }

    if (this.hasProgressTarget) {
      this.progressTarget.style.transform = `translateX(${percentage}%)`;
    }

    if (percentage === 100) {
      this.element.classList.remove(OPEN_CLASS);
      cookie.set(COOKIE_NAME, true, COOKIE_LIFETIME);
    }
  }
}

LoaderController.targets = [
  'loader',
  'percentage',
  'progress',
  'truck',
];

export default LoaderController;
